import {
  BottomSheet,
  BottomSheetHead,
  Button,
} from "@songtradr-one/components-frontend";
import {
  BottomSheetListWrapper,
  MobileButtonsRow,
  Props,
  WizardContext,
  text,
  useWizardController,
} from "./Wizard.Parts";
import { WizardStep } from "./wizard-step/WizardStep";

export const WizardMobile = (props: Props) => {
  const {
    open,
    continueButtonText = text.continue,
    cancelButtonText = text.cancel,
    completeButtonText = text.complete,
    canComplete = true,
    loading = false,
  } = props;

  const {
    pageConfig,
    currentStep,
    childArray,
    isLastStep,
    canContinue,
    canGoBack,
    contextValue,
    handleCancel,
    handleBack,
    handleContinue,
  } = useWizardController(props);

  return (
    <BottomSheet
      draggable={false}
      open={open}
      height="88dvh"
      onOpenChange={(willOpen) => !willOpen && handleCancel()}
      hiddenTitle={pageConfig?.subtitle}
    >
      <BottomSheetHead
        title={pageConfig?.subtitle ?? ""}
        hasDivider={false}
        onBack={canGoBack ? handleBack : undefined}
        onClose={handleCancel}
      />
      <BottomSheetListWrapper>
        <WizardContext.Provider value={contextValue}>
          {childArray.map((child, index) => (
            <WizardStep key={index} isActive={index === currentStep}>
              {child}
            </WizardStep>
          ))}
        </WizardContext.Provider>
      </BottomSheetListWrapper>
      {canComplete && pageConfig && (
        <MobileButtonsRow>
          <Button
            $variant="subtle"
            disabled={loading ? "functional" : false}
            onClick={handleCancel}
          >
            {cancelButtonText}
          </Button>
          <Button
            $variant={isLastStep ? "primary" : "important"}
            $size="normal"
            disabled={!canContinue}
            onClick={handleContinue}
            loading={loading}
          >
            {pageConfig.continueButtonText ??
              (isLastStep ? completeButtonText : continueButtonText)}
          </Button>
        </MobileButtonsRow>
      )}
    </BottomSheet>
  );
};
